<template>
  <v-app>

    <v-app-bar v-if="appFrame" app elevation="0" color="whiteColor" class="appbar">
      <v-container fluid class="pa-0">
        <v-row align="center" no-gutters>
          <!-- Title -->
          <v-col cols="12" sm="4" md="3" class="d-flex align-center">
            <h1 class="title-appbar mb-0">{{ title }}</h1>
          </v-col>

          <!-- Search Bar -->
          <v-col cols="12" sm="4" md="5" class="d-flex justify-center">
            <v-text-field
              v-if="visibleSearch"
              :value="search"
              @input="setSearch"
              filled
              hide-details
              dense
              color="cacique"
              class="search-bar-appbar"
              :placeholder="`Buscar ${searchPlaceholder || ''}`"
              prepend-inner-icon="fa-search"
              rounded
              style="max-width: 420px; width: 100%;"
            >
              <template v-slot:prepend-inner>
                <v-icon small class="mr-2">fa-search</v-icon>
              </template>
            </v-text-field>
          </v-col>

          <!-- Organization Switcher -->
          <v-col cols="12" sm="2" md="2" class="d-flex justify-center">
            <v-menu
              v-if="organizations && business && organizations.length > 0"
              offset-x
              style="z-index: 1000"
              anchor-origin="top left"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-chip v-bind="attrs" v-on="on" color="boxesColor" class="mr-2 chance-border" style="font-size: 1rem; height: 40px; min-width: 220px; position: relative;padding-right: 30px;border: 1px solid #facca8 !important;">
                  <v-avatar class="mr-3" size="36">
                    <v-img :src="business.logo.original" />
                  </v-avatar>
                  <span style="max-width:260px; display:inline-block; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; font-size:0.9em;">
                    {{ (business.name && business.name.length > 0) ? business.name : 'Organización' }}
                  </span>
                  <v-icon  style="position: absolute; right: 10px;" class="ml-3" size="22">fa-chevron-down</v-icon>
                </v-chip>
              </template>
              <v-list nav dense style="max-height: 300px; overflow-y: auto;" color="boxesColor" rounded>
                <v-list-item
                  v-for="organization in organizations"
                  :key="organization[`.key`]"
                  @click="selectBusiness(organization)"
                >
                  <v-avatar class="mr-2" size="32">
                    <v-img :src="organization.logo.original" />
                  </v-avatar>
                  {{ organization.name || 'Organización' }}
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>

          <!-- User Box -->
          <v-col cols="12" sm="2" md="2" class="d-flex justify-end">
            <div v-if="user" class="user-box">
              <div class="user-box__text">
                <div class="user-name">{{ user.name || 'Usuario' }}</div>
                <div class="user-role">{{ roleLabel }}</div>
              </div>
              <img src="@/assets/persons/p-06.png" class="photo" alt="user" />
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>

    <!-- SNACKBAR GLOBAL -->
    <Snackbar class="snackbar-global" />

    <!-- MAIN -->
    <v-main class="main">
      <router-view  />
    </v-main>

    <!-- DRAWER (DESKTOP) -->
    <v-navigation-drawer v-if="navBar && !isMobile" class="navigation" color="boxesColor" app permanent>
      <v-img src="@/assets/logoChance.svg" contain width="70%" class="ma-auto my-6" />

      <div v-for="group in filteredMenu" :key="group.title">
        <span class="subheader ml-2">{{ group.title }}</span>
        <v-list dense color="boxesColor">
          <v-list-item-group>
            <v-list-item v-for="child in group.children" :key="child.title" :to="child.path" class="item-menu"
              active-class="active-menu" exact>

              <v-list-item-icon>
                <v-icon color="cacique" small class="mr-2">{{ child.icon }}</v-icon>

              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ child.title }} </v-list-item-title>
              </v-list-item-content>


            </v-list-item>
          </v-list-item-group>
        </v-list>
      </div>

      <template v-slot:append>
        <div class="pa-4">
          <v-btn block elevation="0" text color="cacique" @click="logOut">
            <v-icon small class="mr-2">fa-sign-out-alt</v-icon>
            Cerrar sesión
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>







  </v-app>
</template>

<script>

import { mapActions, mapState } from 'vuex';
import Snackbar from '@/components/snackbar';
import menu from '@/utils/menu.js'; // Debe exportar { menuItems: [...] }
import { fb, db } from '@/firebase';

export default {
  name: 'App',
  components: { Snackbar },
  data() {
    return {
      appFrame: !!(this.$route.meta && this.$route.meta.appFrame),
      navBar: !!(this.$route.meta && this.$route.meta.navBar),
      title: (this.$route.meta && this.$route.meta.title) || 'Inicio',
      user: this.$store.state.user || null,
      business: this.$store.state.business || null,
      isMobile: false,
      mq: null, // MediaQueryList
      baseRoute: {
        sudo: '/donaciones',
        admin: '/partner/donaciones',
        owner: '/partner/donaciones',
        finance: '/donaciones',
        business: '/partner/donaciones',
        client: '/donaciones',
        partnerAdmin: '/partner/donaciones',
      },
      typeUser: '',
      roleUser: '',
      organizations: [],
    };
  },
  computed: {
    ...mapState(['role', 'visibleSearch', 'searchPlaceholder', 'search']),
    // Rol efectivo: prioriza store.role, si no existe toma user.type
    roleLabel() {
      const map = {
        admin: 'Administrador',
        sudo: 'Súper Admin',
        owner: 'Owner',
        finance: 'Finanzas',
        business: 'Organización',
        client: 'Cliente',
        partnerAdmin: 'Administrador de Organización',

      };
      return map[this.role] || 'Usuario';
    },
    // Menú filtrado por rol (grupo e hijos)
    filteredMenu() {
      const r = this.role;
      const typePermissions = this.typeUser;
      if (!r) return [];
      const items = (menu && menu.menuItems) || [];
      return items
        .filter((grp) => Array.isArray(grp.roles) && grp.roles.includes(r) && (!grp.type || (Array.isArray(grp.type) && grp.type.some(t => typePermissions.includes(t)))))
        .map((grp) => ({
          ...grp,
          children: (grp.children || []).filter(
            (c) => Array.isArray(c.roles) && c.roles.includes(r) && (!c.type || (Array.isArray(c.type) && c.type.some(t => typePermissions.includes(t))))
          ),
        }))
        .filter((grp) => grp.children && grp.children.length > 0);
    },
  },
  watch: {
    // Al cambiar de ruta, refrescar frame/nav/title y aplicar permisos
    $route: {
      immediate: true,
      handler() {
        this.appFrame = !!(this.$route.meta && this.$route.meta.appFrame);
        this.navBar = !!(this.$route.meta && this.$route.meta.navBar);
        this.title = (this.$route.meta && this.$route.meta.title) || 'Inicio';
        this.enforceRoutePermissions();
      },
    },
    // Si cambia el rol (por ejemplo al cargar user), revalidar permisos
    role() {
      this.enforceRoutePermissions();
    },
  },
  methods: {
    ...mapActions(['setUser', 'Alert_', 'setUserValidity_', 'addBusiness', 'setSearch', 'clearSearch']),
    onResize() {
      this.isMobile = window.innerWidth <= 768;
    },
    selectBusiness(business) {
      this.business = business;
      this.addBusiness(business);
    },
    initMatchMedia() {
      if (window.matchMedia) {
        this.mq = window.matchMedia('(max-width: 768px)');
        this.isMobile = !!this.mq.matches;
        // Compatibilidad Vue 2 (addListener/removeListener)
        if (this.mq.addListener) {
          this.mq.addListener((e) => (this.isMobile = !!e.matches));
        }
      } else {
        this.onResize();
        window.addEventListener('resize', this.onResize);
      }
    },
    async logOut() {
      if (!this.user) return;
      await fb.auth().signOut();
      this.business = null;
      this.setUser(null);
      if (this.$route.path !== '/') {
        this.$router.replace({ path: '/' });
      }
    },
    enforceRoutePermissions() {
      const allowed = (this.$route.meta && this.$route.meta.allowedRoles) || null;
      const r = this.role;
      if (allowed && r && !allowed.includes(r)) {
        const target = this.baseRoute[r] || '/';
        if (this.$route.path !== target) this.$router.replace({ path: target });
      }
    },
    async loadUserDoc(uid) {
      const snap = await db.collection('appUsers').doc(uid).get();
      if (!snap.exists) return null;
      return { [".key"]: snap.id,id: snap.id,  ...snap.data() };
    },
    async loadPartnerFirst(user) {
      if (user && Array.isArray(user.businesses) && user.businesses.length > 0) {
        this.organizations = await this.$binding('organizations', db.collection('businesses').where(fb.firestore.FieldPath.documentId(), 'in', user.businesses));
        this.business = this.organizations[0];
        this.addBusiness(this.business);
      } else {
        this.business = [];
      }
    },
    async handleAuthUser(authUser) {
      const needsBasePath = !!(this.$route.meta && this.$route.meta.basePath);

      // No autenticado
      if (!authUser) {
        this.setUser(null);
        this.setUserValidity_(false);

        const protectedNames = new Set([
          'donations',
          'business',
          'coupons',
          'users',
          'messages',
          'campaigns',
          'organizations',
          'kycOnboarding',
          'contracts',
          'smsOtp',
          'cities',
          'sections',
          'paises',
          'usersAdmin',
        ]);
        if (protectedNames.has(String(this.$route.name)) || needsBasePath) {
          if (this.$route.path !== '/') {
            this.$router.replace({ path: '/' });
          }
        }
        return;
      }

      // Autenticado: cargar doc de usuario
      const u = await this.loadUserDoc(authUser.uid);

      if (!u || !u.type || u.active === false) {
        this.setUserValidity_(false);
        this.Alert_({
          text: 'Este perfil de usuario no tiene permitido ingresar a la plataforma',
          timeout: 2000,
          btn_closed: true,
          icon: false,
          iconType: 'mdi-check',
          type: 'error',
        });
        await fb.auth().signOut();
        if (this.$route.path !== '/') {
          this.$router.replace({ path: '/' });
        }
        return;
      }

      // Usuario válido
      this.typeUser = u.type;
      this.roleUser = u.role;
      this.user = u;
      this.setUser(u);
      this.setUserValidity_(true);
      await this.loadPartnerFirst(u);

      // Redirecciones por basePath/rol
      if (this.$route.name === 'login') {
        const target = this.baseRoute[u.type] || '/donaciones';
        if (this.$route.path !== target) {
          this.$router.replace({ path: target });
        }
        return;
      }
      const allowed = (this.$route.meta && this.$route.meta.allowedRoles) || null;
      console.log(allowed, u.type);
      if (allowed && !allowed.includes(u.type)) {
        const target = this.baseRoute[u.type] || '/donaciones';
        if (this.$route.path !== target) this.$router.replace({ path: target });
      }
    },
  },
  mounted() {
    // Responsive
    this.initMatchMedia();

    // Auth listener
    this._unsub = fb.auth().onAuthStateChanged(this.handleAuthUser);
  },
  beforeDestroy() {
    // Limpieza listeners
    if (this._unsub) this._unsub();
    if (this.mq && this.mq.removeListener) this.mq.removeListener((e) => (this.isMobile = !!e.matches));
    window.removeEventListener('resize', this.onResize);
  },
};
</script>

<style lang="scss" scoped>
.appbar {
  .title {
    font-weight: 700;
    letter-spacing: 0.02em;
  }
}

.snackbar-global {
  z-index: 1000;
  width: 100%;
  position: fixed;
  top: 50px;
}

.main {
  background-color: #fffdfb;
}

.user-box {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #1e2428;

  &__text {
    display: flex;
    flex-direction: column;
    line-height: 1.2;
  }

  .user-name {
    font-weight: 700;
    letter-spacing: 0.06em;
    font-size: 20px;
    text-align: end;
    font-family: "nuform-sans-regular" !important;
  }

  .user-role {
    margin-top: 2px;
    font-weight: 400;
    letter-spacing: 0.06em;
    opacity: 0.75;
    font-size: 0.85rem;
    text-align: end;
    font-family: "nuform-sans-regular" !important;
  }

  .photo {
    width: 40px;
    height: 40px;
    object-fit: cover;
    border-radius: 9999px;
  }
}

.navigation {
  .subheader {
    font-size: 12px;
    color: #202020;
    font-family: 'public-sans-regular';
  }

  .item-menu {
    transition: all 0.2s ease;
  }
}

.search-bar {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 420px;
  max-width: 60vw;
  background-color: #fffdfb !important;
  transition: transform 0.15s ease;

  &:hover {
    transform: translateX(-50%) scale(1.03);
  }
}

@media (max-width: 768px) {
  .search-bar {
    display: none;
  }
}
</style>
